import React from 'react'
import { Input, withGrid, CardContent, Card, CardTitle, Button, Select, Option } from '../../../Components'
import styled from 'styled-components'
import { media } from '../../../Themes'

interface IProps {
  serie: string,
  dataDeInicio: string, horaDeInicio: string,
  dataDeFim: string, horaDeFim: string,
  dataDeInicioInscricoes: string, horaDeInicioInscricoes: string,
  dataDeFimInscricoes: string, horaDeFimInscricoes: string,
  dataDeInicioPF: string, horaDeInicioPF: string,
  dataDeFimPF: string, horaDeFimPF: string,
  dataDeInicioSF: string, horaDeInicioSF: string,
  dataDeFimSF: string, horaDeFimSF: string,
  dataDeInicioTF: string, horaDeInicioTF: string,
  dataDeFimTF: string, horaDeFimTF: string,
  observacao: string,
  onChange: any,
  onSave: any,
  onEdit: any,
  editar: boolean
  errors: any
}

interface IState {
}

const Grid = withGrid(CardContent)
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const ButtonGrid = styled(Button) <any>`
  max-width: fit-content;
  justify-self: flex-end;
  grid-column: ${p => p.gridColumn};

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const StyledSelect = styled(Select) <any>`
  grid-column: ${p => p.gridColumn};
`;

export default class ParamsPreProjetoCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {}
  }

  render() {
    const {
      serie,
      dataDeInicio,
      horaDeInicio,
      dataDeFim,
      horaDeFim,
      dataDeInicioInscricoes,
      horaDeInicioInscricoes,
      dataDeFimInscricoes,
      horaDeFimInscricoes,
      dataDeInicioPF,
      horaDeInicioPF,
      dataDeFimPF,
      horaDeFimPF,
      dataDeInicioSF,
      horaDeInicioSF,
      dataDeFimSF,
      horaDeFimSF,
      dataDeInicioTF,
      horaDeInicioTF,
      dataDeFimTF,
      horaDeFimTF,
      observacao,
      errors,
      editar,
      onSave,
      onEdit
    } = this.props

    return (
      <Card>
        <CardTitle>{editar ? 'Editar' : 'Criar'} Parâmetros</CardTitle>
        <CardContentGrid>
          <StyledSelect
            gridColumn='1/2'
            name='serie'
            label='Serie'
            value={serie}
            onChange={this.props.onChange}
            color={
              errors && errors.serie != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.serie != undefined}
            errorMessage={errors && errors.serie}
          >
            <Option value=''>Selecione uma serie...</Option>
            <Option value={4}>4º</Option>
            <Option value={5}>5º</Option>
          </StyledSelect>


          <InputGrid onChange={this.props.onChange}
            name='observacao' gridColumn='2/12' label='Observação' value={observacao}
            color={
              errors && errors.observacao != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.observacao != undefined}
            errorMessage={errors && errors.observacao}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeInicio' gridColumn='1/3' label='Início do Pré-Projeto' type='date' value={dataDeInicio}
            color={
              errors && errors.dataDeInicio != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeInicio != undefined}
            errorMessage={errors && errors.dataDeInicio}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeInicio' gridColumn='3/6' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeInicio}
            color={
              errors && errors.horaDeInicio != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeInicio != undefined}
            errorMessage={errors && errors.horaDeInicio}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeFim' gridColumn='6/9' label='Fim do Pré-Projeto' type='date' value={dataDeFim}
            color={
              errors && errors.dataDeFim != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeFim != undefined}
            errorMessage={errors && errors.dataDeFim}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeFim' gridColumn='9/12' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeFim}
            color={
              errors && errors.horaDeFim != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeFim != undefined}
            errorMessage={errors && errors.horaDeFim}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeInicioInscricoes' gridColumn='1/3' label='Início da Inscrição' type='date' value={dataDeInicioInscricoes}
            color={
              errors && errors.dataDeInicioInscricoes != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeInicioInscricoes != undefined}
            errorMessage={errors && errors.dataDeInicioInscricoes}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeInicioInscricoes' gridColumn='3/6' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeInicioInscricoes}
            color={
              errors && errors.horaDeInicioInscricoes != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeInicioInscricoes != undefined}
            errorMessage={errors && errors.horaDeInicioInscricoes}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeFimInscricoes' gridColumn='6/9' label='Fim da Inscrição' type='date' value={dataDeFimInscricoes}
            color={
              errors && errors.dataDeFimInscricoes != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeFimInscricoes != undefined}
            errorMessage={errors && errors.dataDeFimInscricoes}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeFimInscricoes' gridColumn='9/12' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeFimInscricoes}
            color={
              errors && errors.horaDeFimInscricoes != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeFimInscricoes != undefined}
            errorMessage={errors && errors.horaDeFimInscricoes}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeInicioPF' gridColumn='1/3' label='Início da 1ª Fase' type='date' value={dataDeInicioPF}
            color={
              errors && errors.dataDeInicioPF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeInicioPF != undefined}
            errorMessage={errors && errors.dataDeInicioPF}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeInicioPF' gridColumn='3/6' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeInicioPF}
            color={
              errors && errors.horaDeInicioPF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeInicioPF != undefined}
            errorMessage={errors && errors.horaDeInicioPF}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeFimPF' gridColumn='6/9' label='Fim da 1ª Fase' type='date' value={dataDeFimPF}
            color={
              errors && errors.dataDeFimPF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeFimPF != undefined}
            errorMessage={errors && errors.dataDeFimPF}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeFimPF' gridColumn='9/12' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeFimPF}
            color={
              errors && errors.horaDeFimPF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeFimPF != undefined}
            errorMessage={errors && errors.horaDeFimPF}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeInicioSF' gridColumn='1/3' label='Início da 2ª Fase' type='date' value={dataDeInicioSF}
            color={
              errors && errors.dataDeInicioSF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeInicioSF != undefined}
            errorMessage={errors && errors.dataDeInicioSF}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeInicioSF' gridColumn='3/6' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeInicioSF}
            color={
              errors && errors.horaDeInicioSF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeInicioSF != undefined}
            errorMessage={errors && errors.horaDeInicioSF}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeFimSF' gridColumn='6/9' label='Fim da 2ª Fase' type='date' value={dataDeFimSF}
            color={
              errors && errors.dataDeFimSF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeFimSF != undefined}
            errorMessage={errors && errors.dataDeFimSF}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeFimSF' gridColumn='9/12' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeFimSF}
            color={
              errors && errors.horaDeFimSF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeFimSF != undefined}
            errorMessage={errors && errors.horaDeFimSF}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeInicioTF' gridColumn='1/3' label='Início da 3ª Fase' type='date' value={dataDeInicioTF}
            color={
              errors && errors.dataDeInicioTF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeInicioTF != undefined}
            errorMessage={errors && errors.dataDeInicioTF}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeInicioTF' gridColumn='3/6' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeInicioTF}
            color={
              errors && errors.horaDeInicioTF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeInicioTF != undefined}
            errorMessage={errors && errors.horaDeInicioTF}
          />


          <InputGrid onChange={this.props.onChange}
            name='dataDeFimTF' gridColumn='6/9' label='Fim da 3ª Fase' type='date' value={dataDeFimTF}
            color={
              errors && errors.dataDeFimTF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.dataDeFimTF != undefined}
            errorMessage={errors && errors.dataDeFimTF}
          />
          <InputGrid onChange={this.props.onChange}
            name='horaDeFimTF' gridColumn='9/12' label='Hora' type='hora' mask='99:99' placeholder='00:00' value={horaDeFimTF}
            color={
              errors && errors.horaDeFimTF != undefined ? 'errorColor'
                : 'secondaryLightColor'}
            hasError={errors && errors.horaDeFimTF != undefined}
            errorMessage={errors && errors.horaDeFimTF}
          />

          <ButtonGrid icon='save' gridColumn='10/12'
            onClick={editar ? onEdit : onSave} >
            Salvar
          </ButtonGrid>
        </CardContentGrid>
      </Card>
    )
  }
}

